var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "params"
  }, [_c('h4', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "sort_container"
  }, [_c('v-radio-group', {
    attrs: {
      "items": _vm.sorts,
      "item-text": "label",
      "item-value": "query",
      "label": "Sort by",
      "dark": _vm.$root.theme === 'night' ? true : false,
      "dense": ""
    },
    model: {
      value: _vm.sort,
      callback: function callback($$v) {
        _vm.sort = $$v;
      },
      expression: "sort"
    }
  }, [_vm._l(_vm.sorts, function (items, index) {
    return [_c('v-radio', {
      key: index,
      attrs: {
        "label": items.label,
        "value": items.query,
        "color": _vm.chainColor,
        "dark": _vm.$root.theme === 'night' ? true : false
      }
    })];
  })], 2)], 1), _c('DateForm', {
    on: {
      "change_start": _vm.setStart,
      "change_end": _vm.setEnd
    }
  }), _c('div', {
    staticClass: "limit_container"
  }, [_c('v-radio-group', {
    staticClass: "limit_container_group",
    attrs: {
      "items": _vm.limits,
      "label": "Limit Results",
      "dark": _vm.$root.theme === 'night' ? true : false,
      "dense": ""
    },
    model: {
      value: _vm.limit,
      callback: function callback($$v) {
        _vm.limit = $$v;
      },
      expression: "limit"
    }
  }, [_vm._l(_vm.limits, function (items, index) {
    return [_c('v-radio', {
      key: index,
      attrs: {
        "label": items.toString(),
        "value": items,
        "color": _vm.chainColor,
        "dark": _vm.$root.theme === 'night' ? true : false
      }
    })];
  })], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }